import { css, html, LitElement } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import '../ChatTile/ChatTile';
import '../ReadMark/DoubleMark/DoubleMark';
import '../ReadMark/BlueReadMark/BlueReadMark';
import '../../../stories/Components/MessageBubble/DocumentMessageBubble/DocumentMessageBubble';
import '../../../stories/Components/MessageBubble/ImageMessageBubble/ImageMessageBubble';
import '../../../stories/Components/MessageBubble/VideoMessageBubble/VideoMessageBubble';
import '../../../stories/Components/MessageBubble/OutgoingTextMessageBubble/OutgoingTextMessageBubble';
import '../../../stories/Components/MessageBubble/LinkMessageBubble/LinkMessageBubble';
import'../../../components/ChatUIComponent/AudioBubble'
import { generateProfileImageByInitials, getFormattedDeliveryTime } from '../../../lib/helpers';
import { Image } from '../Image/Image';
import { Text } from '../Text/Text';

class MessageInfo extends LitElement {
  constructor() {
    super();
  }
  static properties = {
    padding: { type: String },
    margin: { type: String },
    width: { type: String },
    height: { type: String },
    borderRadius: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },

    backgroundColor: { type: String },
    messageBackgroundColor: { type: String },
    statusBackgroundColor: { type: String },
    textColor: { type: String },
    fontSize: { type: String },
    fontWeight: { type: String },
    fontFamily: { type: String },
    fontStyle: { type: String },
    lineHeight: { type: String },
    textAlign: { type: String },

    contactImage: { type: String },
    contactName: { type: String },
    contactEmail: { type: String },

    isGroup: { type: Boolean },
    messageDate: { type: String },
    messagePreviewText: { type: String },
    messageDeliveryTime: { type: Number },
    messageReadTime: { type: Number },
    pendingReadCount: { type: Number },
    pendingDeliveryCount: { type: Number },
    renderAttachmentMessage: { type: Function },
    selectedMessage: { type: Object },
    onMediaClick: { type: Function },
    closePopup: { type: Function },
    allAttachments: { type: Array },
    deliveryUserList: { type: Array },
    readUserList: { type: Array },
  };

  static styles = css`
    .message-info-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
      box-sizing: border-box;
      background-color:var(--bg-primary-color)
    }

    .message-info-header {
      display: flex;
      align-items: center;
      gap: 10px;
      padding-top: 15px;
      padding-bottom: 15px;
      color:var(--text-primary-color);
    }

    .message-info-body {
      display: flex;
      flex-direction: column;
      gap: 10px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .message-delivery-status-mark,
    .message-read-status-mark {
      display: flex;
      align-items: center;
    }

    double-mark,
    blue-read-mark {
      display: flex;
    }

    .message-preview-container {
      padding: 10px;
      display: flex;
      flex-direction: column;
      border-radius: 5px;
    }
    .message-preview {
      max-height: 250px;
      overflow: auto;
      display: flex;
      align-self: end;
    }

    .message-delivery-status,
    .message-read-status {
      display: flex;
      flex-direction: column;
      padding: 5px;
    }

    .message-date-label {
      align-self: center;
      padding: 5px 20px;
      border-radius: 10px;
    }

    .message-preview-text {
      align-self: end;
      padding: 10px;
    }
    .message-status {
      padding: 5px;
    }
       .userTile {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .userdetail {
    flex-grow: 1;
    padding: 8px 0;
    border-top: 1px solid var(--bg-secondary-color);
  }

  .messageTime {
    display: block;
    color: var(--text-secondary-color);
    font-size: 14px;
    line-height: 20px;
    margin-top: 2px;
  }

  .image-container {
    flex-shrink: 0;
  }
  `;

  extractUrls(text) {
    if (!text) return [];
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.match(urlRegex) || [];
  }
  renderMessage(message) {
    const urls = this.extractUrls(message?.body);
    const hasLinks = urls?.length > 0;
    if (message?.body && !message?.attachments?.length) {
      if (hasLinks) {
        return html`
          <link-preview
            .isMessageInfo=${true}
            .url=${urls[0]}
            .isRead=${message?.readByAll}
            .isDelivered=${message?.deliveredToAll}
            .time=${message?.sentAt}
            .timeColor=${'var(--text-outgoing-time)'}
            .backgroundColor=${'var(--bg-outgoing-message)'}
            .message=${message?.body}
            .isSelf=${true}
            .mentionedUsers=${message?.mentionedUsers}
            .time=${message?.sentAt}
            .isRead=${message?.readByAll}
            .isDelivered=${message?.deliveredToAll}
            .textColor=${'var(--text-outgoing-message)'}
            .message=${message?.body}
            .mentionedUsers=${message?.mentionedUsers}
            .bgColor=${'var(--bg-outgoing-message)'}
            .borderRadius=${'6px 6px 0 6px'}
          ></link-preview>
        `;
      } else {
        return html`
          <outgoing-text-message-bubble
            .isRead=${message?.readByAll}
            .padding=${'10px 10px 1px 10px'}
            .borderRadius=${'10px 10px 0 10px'}
            .textContent=${message?.body}
            .time=${message?.sentAt}
            .bgColor=${'var(--bg-outgoing-message)'}
            .textColor=${'var(--text-outgoing-message)'}
            .isDelivered=${message?.deliveredToAll}
            .mentionedUsers=${message?.mentionedUsers}
            .timeColor=${'var(--text-outgoing-time)'}
          ></outgoing-text-message-bubble>
        `;
      }
    } else {
      if (message?.attachments?.length > 1 && !message?.attachments?.[0]?.mimeType?.startsWith('application/')) {
        return html`
          <image-message
            .height=${'220px'}
            .width=${'250px'}
            .padding=${'10px 10px 10px 10px'}
            .imageSrc=${message?.attachments?.[0]?.mediaUrl}
            .borderWidth=${'5px'}
            .borderColor=${'var(--bg-grey-color)'}
            .borderStyle=${'solid'}
            .allAttachments=${this.allAttachments}
            .onImageClick=${this.onMediaClick}
            .totalMedia=${message?.attachments?.length - 1}
            .mediaType=${message?.attachments?.[0]?.mediaType}
            .time=${message?.sentAt}
            .isSelf=${true}
            .isRead=${message?.readByAll}
            .isDelivered=${message?.deliveredToAll}
            .textColor=${'var(--text-outgoing-message)'}
            .message=${message?.body}
            .mentionedUsers=${message?.mentionedUsers}
            .bgColor=${'var(--bg-outgoing-message)'}
            .borderRadius=${'6px 6px 0 6px'}
            .timeColor=${'var(--text-outgoing-time)'}
          ></image-message>
        `;
      } else {
        return message?.attachments?.map((attachment, index) => {
          if (attachment?.mimeType?.startsWith('application/') || message?.customType === 'AttachmentMessage:File') {
            return html`
              <document-message
                .docType=${attachment?.mimeType}
                .fileName=${attachment?.name}
                .href=${attachment?.mediaUrl}
                .width=${'220px'}
                .padding=${'10px 10px 20px 10px'}
                .docName=${attachment?.name}
                .time=${message?.sentAt}
                .isSelf=${true}
                .isRead=${message?.readByAll}
                .isDelivered=${message?.deliveredToAll}
                .textColor=${'var(--text-outgoing-message)'}
                .message=${message?.body}
                .mentionedUsers=${message?.mentionedUsers}
                .bgColor=${'var(--bg-outgoing-message)'}
                .borderRadius=${'6px 6px 0 6px'}
                .timeColor=${'var(--text-outgoing-time)'}
              ></document-message>
            `;
          }
          if (attachment?.mimeType?.startsWith('video/') || message?.customType === 'AttachmentMessage:Video') {
            return html` <video-message
              .height=${'220px'}
              .width=${'250px'}
              .padding=${'10px 10px 30px 10px'}
              .type=${attachment?.mimeType}
              .videoSrc=${attachment?.mediaUrl}
              .time=${message?.sentAt}
              .isSelf=${true}
              .isRead=${message?.readByAll}
              .isDelivered=${message?.deliveredToAll}
              .textColor=${'var(--text-outgoing-message)'}
              .message=${message?.body}
              .mentionedUsers=${message?.mentionedUsers}
              .bgColor=${'var(--bg-outgoing-message)'}
              .borderRadius=${'6px 6px 0 6px'}
              .timeColor=${'var(--text-outgoing-time)'}
            ></video-message>`;
          }
          if (attachment?.mimeType?.startsWith('image/') || message?.customType === 'AttachmentMessage:Image') {
            return html` <image-message
              .height=${'220px'}
              .width=${'250px'}
              .padding=${'10px 10px 10px 10px'}
              .imageSrc=${attachment?.mediaUrl}
              .borderWidth=${'5px'}
              .borderColor=${'var(--bg-grey-color)'}
              .borderStyle=${'solid'}
              .allAttachments=${this.allAttachments}
              .onImageClick=${this.onMediaClick}
              .time=${message?.sentAt}
              .isSelf=${true}
              .isRead=${message?.readByAll}
              .isDelivered=${message?.deliveredToAll}
              .textColor=${'var(--text-outgoing-message)'}
              .message=${message?.body}
              .mentionedUsers=${message?.mentionedUsers}
              .bgColor=${'var(--bg-outgoing-message)'}
              .borderRadius=${'6px 6px 0 6px'}
              .timeColor=${'var(--text-outgoing-time)'}
            ></image-message>`;
          }
          if (attachment?.mimeType?.startsWith('audio/') || message?.customType === 'AttachmentMessage:Image') {
            return html` <audio-bubble
              .audioUrl=${attachment?.mediaUrl}
              .time=${message?.sentAt}
              .isSelf=${true}
              .isRead=${message?.readByAll}
              .isDelivered=${message?.deliveredToAll}
              .showFooter=${true}
              .textColor=${'var(--text-outgoing-message)'}
              .timeColor=${'var(--text-outgoing-time)'}
            ></audio-bubble>`;
          }
        });
      }
    }
  }

  renderDeliveryUser() {
    return html`
      <div style="padding: 16px 0;background-color:var(--bg-secondary-color);">
        <div style="display: flex; justify-content: space-between; padding: 0 16px 8px 16px">
          <span style="color: var(--text-secondary-color)">Delivered to</span>
          <span>
                           <double-mark></double-mark>
          </span>
        </div>
        ${this.deliveryUserList.map(user => html`
          <div class='userTile' style="padding: 0px 10px;">
            <div class="image-container">
              ${Image({
      src: user.userProfileImageUrl,
      height: '40px',
      width: '40px',
      placeholderImage: generateProfileImageByInitials(user?.userName),
      borderRadius: '50%',
      objectFit: 'cover',
      cursor: 'pointer',
    })}
            </div>
            <div class='userdetail' style="width: 100%; border-color: var(--bg-secondary-color)">
              <div style="display: flex; align-items: center;">
                ${Text({
      fontSize: '16px',
      fontWeight: '500',
      content: user?.userName || '',
      color: 'var(--text-primary-color)',
      textAlign: 'left'
    })}
                ${user.emoji ? html`<span style="margin-left: 4px">${user.emoji}</span>` : ''}
              </div>
              <span class='messageTime'>${getFormattedDeliveryTime(user?.timestamp)}</span>
            </div>
          </div>
        `)}
        <div style="display: flex; justify-content: space-between; padding: 0 16px 8px 16px" >
                  ${this.pendingDeliveryCount > 0 ? html`<span style="color: var(--text-secondary-color);font-size:14px;" >${this.pendingDeliveryCount} remaining</span>` : null}
                    </div>
      </div>
    `;
  }

  renderReadUser() {
    return html`
      <div style="padding: 16px 0;background-color:var(--bg-secondary-color);">
        <div style="display: flex; justify-content: space-between; padding: 0 16px 8px 16px">
          <span style="color: var(--text-secondary-color)">Read by</span>
          <span>
           <blue-read-mark></blue-read-mark>
          </span>
        </div>
        ${this.readUserList.map(user => html`
          <div class='userTile' style="padding: 0px 10px;">
            <div class="image-container">
              ${Image({
      src: user.userProfileImageUrl,
      height: '40px',
      width: '40px',
      placeholderImage: generateProfileImageByInitials(user?.userName),
      borderRadius: '50%',
      objectFit: 'cover',
      cursor: 'pointer',
    })}
            </div>
            <div class='userdetail' style="width: 100%; border-color: var(--bg-secondary-color)">
              <div style="display: flex; align-items: center;">
                ${Text({
      fontSize: '16px',
      fontWeight: '500',
      content: user?.userName || '',
      color: 'var(--text-primary-color)',
      textAlign: 'left'
    })}
              </div>
              <span class='messageTime'>${getFormattedDeliveryTime(user?.timestamp)}</span>
            </div>
          </div>
        `)}
        <div style="display: flex; justify-content: space-between; padding: 0 16px 8px 16px">
        ${this.pendingReadCount > 0 ? html`<span style="color: var(--text-secondary-color);font-size:14px;" >${this.pendingReadCount} remaining</span>` : null}
        </div>
      </div>
    `;
  }


  render() {
    return html`
      <div
        class="message-info-container"
        style=${styleMap({
          padding: this.padding,
          margin: this.margin,
          width: this.width,
          height: this.height,
          borderRadius: this.borderRadius,
          borderWidth: this.borderWidth,
          borderColor: this.borderColor,
          borderStyle: this.borderStyle,
          backgroundColor: this.backgroundColor,
          color: this.textColor,
          fontSize: '16px',
          fontWeight: this.fontWeight,
          fontFamily: this.fontFamily,
          fontStyle: this.fontStyle,
          lineHeight: this.lineHeight,
          textAlign: this.textAlign,
        })}
      >
        <div class="message-info-header">
          <svg @click="${this.closePopup}" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
            <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
          </svg>
          <span class="message-info-label">Message Info</span>
        </div>

        <div class="message-info-body">
          <div class="message-preview-container" style="font-size:14px; background-color: ${this.messageBackgroundColor}">
            <div class="message-preview">${this.renderMessage(this.selectedMessage)}</div>
          </div>

          ${this.isGroup ? html`
          ${this.renderReadUser()}
          ${this.renderDeliveryUser()}
          ` : html` <div class="message-status" style="background-color: ${this.statusBackgroundColor}">
            <div class="message-delivery-status" style="border-bottom: 1px solid ${`var(--bg-secondary-color)`}">
              <div class="message-delivery-status-mark">
                <double-mark></double-mark>
                <span class="message-delivery-status-label" style="font-size:16px">Delivered</span>
              </div>
              <span class="message-delivery-status-time" style="font-size: 14px">${getFormattedDeliveryTime(this.messageDeliveryTime)}</span>
            </div>

            <div class="message-read-status">
              <div class="message-read-status-mark">
                <blue-read-mark></blue-read-mark>
                <span class="message-read-status-label" style="font-size:16px">Read</span>
              </div>
              <span class="message-read-status-time" style="font-size: 14px">${getFormattedDeliveryTime(this.messageReadTime)}</span>
            </div>
          </div>`}
        </div>
      </div>
    `;
  }
}

customElements.define('message-info', MessageInfo);
